import { Link } from "react-router-dom";
import { useLenis } from "@/components/SmoothScrollProvider";
import { CLUSTER_META } from "@/components/clusters/clusterMeta";

const COLUMNS = [
  {
    heading: "Explore",
    links: [
      { label: "Warehouse", href: "#warehouse" },
      { label: "Fabrics", href: "#fabrics" },
      { label: "Our story", href: "#about" },
      { label: "Pricing", href: "#pricing" },
      { label: "Bulk orders", href: "#contact" },
      // Route links to the SEO fabric category pages.
      ...CLUSTER_META.map((p) => ({ label: p.label, href: `/${p.slug}`, route: true })),
    ],
  },
  {
    heading: "Get in touch",
    links: [
      { label: "+1 718 781 4444", href: "tel:+17187814444" },
      { label: "WhatsApp", href: "https://wa.me/17187814444", external: true },
      { label: "magnummoez@aol.com", href: "mailto:magnummoez@aol.com" },
    ],
  },
];

export const Footer = () => {
  const lenis = useLenis();

  const go = (href) => (e) => {
    if (!href.startsWith("#") || href === "#") return;
    e.preventDefault();
    const el = document.getElementById(href.slice(1));
    if (!el) return;
    if (lenis) lenis.scrollTo(el, { duration: 1.4 });
    else el.scrollIntoView({ behavior: "smooth" });
  };

  const backToTop = (e) => {
    e.preventDefault();
    if (lenis) lenis.scrollTo(0, { duration: 1.6 });
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer data-testid="site-footer" className="seam-top bg-charcoal">
      <div className="mx-auto max-w-[1200px] px-5 pb-8 pt-16 md:px-12">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-3">
          <div>
            <p className="wordmark text-[13px] text-warmwhite">Spandex American Fabrics</p>
            <p className="eyebrow mt-1.5 text-[12px] text-warmwhite">Cherechian Trading Co</p>
            <p className="eyebrow mt-4 text-[11px] leading-relaxed text-mist">
              © 2026 Spandex American Fabrics.
              <br />
              Made in the USA.
            </p>
          </div>
          {COLUMNS.map((col) => (
            <nav key={col.heading} aria-label={col.heading}>
              <p className="eyebrow text-[11px] text-kraft">{col.heading}</p>
              <ul className="mt-4 flex flex-col gap-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    {l.route ? (
                      <Link
                        to={l.href}
                        data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                        className="font-inter text-sm text-mist transition-colors duration-300 ease-out hover:text-warmwhite"
                      >
                        {l.label}
                      </Link>
                    ) : (
                      <a
                        href={l.href}
                        onClick={go(l.href)}
                        {...(l.external
                          ? { target: "_blank", rel: "noopener noreferrer" }
                          : {})}
                        data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                        className="font-inter text-sm text-mist transition-colors duration-300 ease-out hover:text-warmwhite"
                      >
                        {l.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-14 flex items-center justify-between border-t border-graphite pt-6">
          <p className="font-inter text-sm text-mist">
            Spandex American Fabrics is Cherechian Trading Co. Same family, same
            fabric business, since 1967.
          </p>
          <a
            href="#hero"
            onClick={backToTop}
            data-testid="footer-back-to-top"
            className="eyebrow shrink-0 text-[12px] text-mist transition-colors duration-300 ease-out hover:text-warmwhite"
          >
            Back to top ↑
          </a>
        </div>
      </div>
    </footer>
  );
};
